import type { FieldErrors } from "react-hook-form"
import { _get } from "@/utils"

export default (errors: FieldErrors, path: string): string | undefined => {
  const node = _get(path, errors) as unknown
  if (
    node &&
    typeof node === "object" &&
    "message" in node &&
    typeof node.message === "string"
  ) {
    return node.message
  }
}
